import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/gci/suppliers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}gci/suppliers/delete`,
        endpoint: config.endpoints.backend + 'gci/suppliers/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'gci/companies/getall'
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'supplier_type',
                type: 'select',
                label: 'Tipo de Fornecedor',
                options: [
                    { label: 'Física', value: 'F' },
                    { label: 'Jurídica', value: 'J' }
                ],
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Fornecedores',
        labelTitleButtonAdd: 'Incluir novo Fornecedor',
        fieldsShowOnDelete: ['supplier_name', 'document'],
        showPrintButtons: true,
        formFilters: !profileFilter.gci_company_id ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'supplier_name',
                label: 'Nome / Razão Social'
            },
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'document',
                label: 'CPF / CNPJ'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
